import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useLocation } from "react-router-dom";

export default function TopProgress() {
  const location = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
    const t = setTimeout(() => setShow(false), 900);
    return () => clearTimeout(t);
  }, [location.pathname]);
  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-[2px] bg-transparent overflow-hidden pointer-events-none">
      <AnimatePresence>
        {show && (
          <motion.div
            key={location.pathname}
            initial={{ width: "0%" }}
            animate={{ width: "100%" }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.8, ease: [0.2, 0.7, 0.2, 1] }}
            className="h-full bg-gradient-to-r from-violet-500 via-fuchsia-400 to-violet-300"
          />
        )}
      </AnimatePresence>
    </div>
  );
}
